function Navbar() {
  // Here Navbar component contains the title of the website
  return (
    <div>
      <nav className="navbar py-4">
        <h1 className="text-3xl font-bold text-center text-white"> Top Courses </h1>
      </nav>
    </div>
  );
}

export default Navbar;
